const zustandXOpts = {
    devtools: {
        enabled: process.env.NODE_ENV !== 'production'
    },
    persist: {
        enabled: true,
        name: 'main',
        partialize: (state) => ({
            token: state.token,
            chosenCompanyId: state.chosenCompanyId,
        }),
    }
}

export default zustandXOpts;